import React from 'react';
import PropTypes from 'prop-types';
import {GlossaryDispatch} from '../index';
import style from './style.module.scss';

const ENTER_KEY = 'Enter';
const INPUT_SEARCH_TYPE = 'text';
const SEARCH_PLACEHOLDER = 'Search';
/**
 * SearchInput
 *  - Input where we type the Search Text.
 */
export function SearchInput(props) {
  const {onSearchInputChange} = React.useContext(GlossaryDispatch);

  const onKeyUp = (event) => {
    event.preventDefault();
    if (event.key === ENTER_KEY) {
      props.onEnterKey(event);
    }
  };

  return (
    <input
      type={INPUT_SEARCH_TYPE}
      value={props.value}
      onChange={onSearchInputChange}
      onKeyUp={onKeyUp}
      placeholder={SEARCH_PLACEHOLDER}
      className={style.searchInput}
    />
  );
}

SearchInput.propTypes = {
  /**
   * String value to be displayed as search text
   */
  value: PropTypes.string.isRequired,
  /**
   * Callback function to be executed when `Enter` button is clicked
   */
  onEnterKey: PropTypes.func.isRequired,
};

SearchInput.defaultProps = {
  value: '',
};
